<template>
    <div v-if="show" class="show-more-container">
        <button 
            class="show-more-button" 
            @click="handleClick" 
            :disabled="loading"
        >
            <span v-if="!loading">{{ buttonText }}</span>
            <span v-else>{{ loadingText }}</span>
            <svg v-if="!loading" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="#6C757D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    name: 'ShowMoreButton',
    props: {
        show: {
            type: Boolean,
            default: true
        },
        loading: {
            type: Boolean,
            default: false
        },
        buttonText: {
            type: String,
            default: 'Toon meer resultaten'
        },
        loadingText: {
            type: String,
            default: 'Laden...'
        }
    },
    methods: {
        handleClick() {
            this.$emit('click');
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../assets/style/_variables.scss";

.show-more-container {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    margin-bottom: 16px;
}

.show-more-button {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    background: white;
    border: 1px solid #DEE2E6;
    border-radius: 6px;
    color: #6C757D;
    font-family: Gotham;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
}

.show-more-button:hover {
    background-color: #F8F9FA;
    border-color: #ADB5BD;
}

.show-more-button:active {
    background-color: #E9ECEF;
}

.show-more-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.show-more-button:disabled:hover {
    background-color: white;
    border-color: #DEE2E6;
}
</style>
